import type { TableColumnDefinition, TableColumnType } from '@gitbook/doc-core';

import { checkboxDefinitionSpec } from './checkbox';
import { contentRefDefinitionSpec } from './content-ref';
import { filesDefinitionSpec } from './files';
import { imageDefinitionSpec } from './image';
import { numberDefinitionSpec } from './number';
import { ratingDefinitionSpec } from './rating';
import { selectDefinitionSpec } from './select';
import { textDefinitionSpec } from './text';
import type { TableDefinitionRenderSpec } from './types';
import { usersDefinitionSpec } from './users';

/**
 * Spec for all type definitions.
 */
export const definitionSpecs: { [type in TableColumnType]: TableDefinitionRenderSpec<any, any> } = {
    checkbox: checkboxDefinitionSpec,
    number: numberDefinitionSpec,
    text: textDefinitionSpec,
    files: filesDefinitionSpec,
    select: selectDefinitionSpec,
    users: usersDefinitionSpec,
    rating: ratingDefinitionSpec,
    'content-ref': contentRefDefinitionSpec,
    image: imageDefinitionSpec,
};

export const orderedDefinitionTypes: TableColumnType[] = [
    'text',
    'number',
    'checkbox',
    'select',
    'users',
    'files',
    'image',
    'content-ref',
    'rating',
];

/**
 * Get a title for a column.
 */
export function getColumnTitle(col: TableColumnDefinition): string {
    return col.title || definitionSpecs[col.type].title;
}
